<template>
  <section id="card-images">
    <b-row>
      <b-col
          xl="12"
      >
        <swiper
            ref="swiperTop"
            class="swiper-gallery gallery-top"
            :options="swiperOptions"
            style="height: 62vh; border-radius: 0.357rem !important;"
        >
          <swiper-slide
              v-for="(data,index) in swiperData"
              :key="index"
          >
            <b-card
                :img-src="data.img"
                overlay
                text-variant="white"
                body-class="bg-overlay"
                class="align-middle"
            >
              <span class="text-white font-weight-bold font-large-5 d-none d-xl-block ml-xl-5 pl-xl-1 mt-1">
                Smart<br>Agro
              </span>
              <span class="text-white font-weight-bold font-large-4 d-none ml-lg-5 pl-xl-1 mt-lg-2 d-lg-block d-xl-none mt-1">
                SMART<br>AGRO
              </span>
              <span class="text-white font-weight-bold text-center font-large-3 mt-md-1 d-none d-md-block d-lg-none ">
                SMART<br>AGRO
              </span>
              <span class="text-white font-weight-bold text-center font-large-2 mt-sm-3 d-none d-sm-block d-md-none ">
                SMARTAGRO
              </span>
              <p class="text-white font-weight-bold text-center font-large-1 d-sm-none ">
                SMARTAGRO
              </p>

              <span class="text-white font-weight-bold font-large-2 d-none ml-xl-5 pl-xl-1 d-xl-block ">
                Agrovision Perú S.A.C
              </span>
              <span class="text-white font-weight-bold font-large-1 d-none ml-lg-5 pl-xl-1 d-lg-block d-xl-none ">
                Agrovision Perú S.A.C
              </span>
              <span class="text-white font-weight-bold text-center font-large-1 d-none d-md-block d-lg-none ">
                Agrovision Perú S.A.C
              </span>
              <span class="text-white font-weight-bold text-center font-medium-5 d-none d-sm-block d-md-none ">
                Agrovision Perú S.A.C
              </span>
              <p class="text-white font-weight-bold text-center font-small-5 d-sm-none ">
                Agrovision Perú S.A.C
              </p>
            </b-card>
          </swiper-slide>

          <div
              slot="button-next"
              class="swiper-button-next swiper-button-white text-white"
          />
          <div
              slot="button-prev"
              class="swiper-button-prev swiper-button-white"
          />
          <div
              slot="pagination"
              class="swiper-pagination"
          />
        </swiper>

        <swiper
            ref="swiperThumbs"
            class="swiper gallery-thumbs"
            :options="swiperOptionThumbs"
            style="border-radius: 0.357rem !important;"
        >
          <swiper-slide
              v-for="(data,index) in swiperData"
              :key="index"
          >
            <b-img
                :src="data.img"
                fluid-grow
            />
          </swiper-slide>
        </swiper>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { BImg, BRow, BCol, BCard, BCardText, BCardTitle, } from 'bootstrap-vue'
import 'swiper/css/swiper.css'
import axiosIns from '@/libs/axios'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg, BRow, BCol, BCard, BCardText, BCardTitle,
  },
  data() {
    return {
      swiperData: [
        { img: require('@/assets/images/slider/1.webp') },
        { img: require('@/assets/images/slider/2.webp') },
        { img: require('@/assets/images/slider/3.webp') },
        { img: require('@/assets/images/slider/4.webp') },
        { img: require('@/assets/images/slider/5.webp') },
        { img: require('@/assets/images/slider/6.webp') },
        { img: require('@/assets/images/slider/7.webp') },
        { img: require('@/assets/images/slider/8.webp') },
        { img: require('@/assets/images/slider/9.webp') },
        { img: require('@/assets/images/slider/10.webp') },
        { img: require('@/assets/images/slider/11.webp') },
        { img: require('@/assets/images/slider/12.webp') },
        { img: require('@/assets/images/slider/13.webp') },
        { img: require('@/assets/images/slider/14.webp') },
        { img: require('@/assets/images/slider/15.webp') },
        { img: require('@/assets/images/slider/16.webp') },
        { img: require('@/assets/images/slider/17.webp') },
        { img: require('@/assets/images/slider/18.webp') },
        { img: require('@/assets/images/slider/19.webp') },
        { img: require('@/assets/images/slider/20.webp') },
        { img: require('@/assets/images/slider/21.webp') },
        { img: require('@/assets/images/slider/22.webp') },
        { img: require('@/assets/images/slider/23.webp') },
        { img: require('@/assets/images/slider/24.webp') },
        { img: require('@/assets/images/slider/25.webp') },
        { img: require('@/assets/images/slider/26.webp') },
        { img: require('@/assets/images/slider/27.webp') },
        { img: require('@/assets/images/slider/28.webp') },
        { img: require('@/assets/images/slider/29.webp') },
        { img: require('@/assets/images/slider/30.webp') },
        { img: require('@/assets/images/slider/31.webp') },
        { img: require('@/assets/images/slider/32.webp') },
        { img: require('@/assets/images/slider/33.webp') },
        { img: require('@/assets/images/slider/34.webp') },
      ],

      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        autoplay: {
          delay: 2800,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    }
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    async getData() {
      await axiosIns.get('configuracion/smartagro/home/')

    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/swiper.scss';
</style>
